"use strict";
/**
 * ! WARNING: RegExps are stateful when they use /g or /y flags - RegExps using these flags MUST be wrapped in functions to provide a fresh one every time.
 * ? Info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.charCountMatchingRegex = exports.DOMAIN_REGEX = exports.CITY_REGEX = exports.NUMERIC_REGEX = exports.ONLY_ALPHANUMERIC_SPACE_REGEX = exports.HTTPS_URL_REGEX = exports.MODERN_URL_REGEX = exports.URL_REGEX = exports.EMAIL_REGEX = exports.EIN_REGEX = exports.US_ZIP_REGEX = void 0;
exports.findURLs = findURLs;
// All regexes must be unit tested - just like everything else in this package
exports.US_ZIP_REGEX = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
exports.EIN_REGEX = new RegExp(/^(\d{2}-\d{7})$|^(\d{3}-\d{2}-\d{4})$/);
exports.EMAIL_REGEX = new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
/**
 * Used to find all urls when scanning messages
 * It took a ridiculous amount of time to find a regex that passed the unit tests: https://stackoverflow.com/a/42619368/7977259
 */
exports.URL_REGEX = new RegExp(/^((https?|ftp|smtp):\/\/)?(www.)?[-a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-_#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/);
/**
 * This regex supports modern URLS like https://www.tiktok.com/@cnect.careers and nested subdomains
 */
exports.MODERN_URL_REGEX = new RegExp(/^((https?|ftp|smtp):\/\/)?(www\.)?([a-zA-Z0-9][a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9#?=@&%_.-]+)*\/?$/);
exports.HTTPS_URL_REGEX = new RegExp(/^https:\/\/(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-_#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/);
/** used to validate string contains only letters, numbers or spaces */
exports.ONLY_ALPHANUMERIC_SPACE_REGEX = new RegExp('^[ a-zA-Z0-9]+$');
exports.NUMERIC_REGEX = new RegExp('^[0-9]+$');
exports.CITY_REGEX = new RegExp("^[a-zA-Z\u0080-\u024F]+(?:. |-| |')*([1-9a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$");
/** e.g. example.com, ci-app.example.com */
exports.DOMAIN_REGEX = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]))*$/;
const charsMatchingRegex = (regex, value) => value.match(new RegExp(regex, 'g'));
/**
 * Counts the characters matching a given regex
 * @param regex
 * @param value
 * @returns
 */
const charCountMatchingRegex = (regex, value) => (charsMatchingRegex(regex, value) ?? []).length;
exports.charCountMatchingRegex = charCountMatchingRegex;
function findURLs(text) {
    const URL_REGEX = /(https?:\/\/[a-zA-Z0-9-]+\.[^\s!()@#$%^&*]{2,}|www\.[a-zA-Z0-9-]+\.[^\s!()@#$%^&*]{2,})/g;
    const matches = text.match(URL_REGEX);
    return matches;
}
